import React from "react";
import InformerWidget from "../../../UI/InformerWidget";
const ProfileStats = ({
  views,
  likes,
  interests,
  shortlisted,
  saved,
  favorites
}) => {
  return (
    <div className="row">
      <div className="col-md-2 col-xs-6">
        <InformerWidget text={views} description="Profile Views" />
      </div>
      <div className="col-md-2 col-xs-6">
        <InformerWidget warning text={likes} description="Likes" />
      </div>
      <div className="col-md-2 col-xs-6">
        <InformerWidget
          info
          text={interests}
          description="Expressed-Interest"
        />
      </div>
      <div className="col-md-2 col-xs-6">
        <InformerWidget success text={shortlisted} description="ShortListed" />
      </div>
      <div className="col-md-2 col-xs-6">
        <InformerWidget primary text={saved} description="Saved" />
      </div>
      <div className="col-md-2 col-xs-6">
        <InformerWidget
          danger
          text={favorites}
          description="Added To Favourite"
        />
      </div>
    </div>
  );
};

export default ProfileStats;



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileStats/index.js